interface Translation {
  comingSoon: string;
  tagline: string;
  description1: string;
  description2: string;
  notifyMe: string;
}

interface Translations {
  [key: string]: Translation;
}

export const translations: Translations = {
  fr: {
    comingSoon: "BIENTÔT DISPONIBLE",
    tagline: "N'importe où, n'importe quand",
    description1: "Votre aventure urbaine est sur le point de commencer.",
    description2: "Le futur de la mobilité vous attend.",
    notifyMe: "Tenez-moi informé",
  },
  en: {
    comingSoon: "COMING SOON",
    tagline: "Anywhere, anytime",
    description1: "Your urban adventure is about to begin.",
    description2: "The future of mobility awaits.",
    notifyMe: "Notify Me",
  },
}; 